import { useMemo } from 'react';
import { Alert } from '@mui/material';
import { HomePlacementErrors } from '../../constants/errors';

interface HomeModelPlacementToastProps {
  homeModelPlacementError?: string | undefined;
}

export const HomeModelPlacementToast = ({
  homeModelPlacementError,
}: HomeModelPlacementToastProps) => {
  const message = useMemo(() => {
    switch (homeModelPlacementError) {
      case HomePlacementErrors.PROPERTY_BOUNDARY_ERROR:
        return 'The home is outside the property boundary';
      case HomePlacementErrors.FLOOD_ZONE_WARNING:
        return 'The home is placed over a flood zone';
      case HomePlacementErrors.WETLAND_ERROR:
        return 'The home is placed over a wetland';
      case HomePlacementErrors.SETBACK_ERROR:
        return 'The home is placed outside the designated setbacks';
    }
  }, [homeModelPlacementError]);

  return (
    <Alert
      sx={{
        position: 'relative',
        width: '50%',
        margin: 'auto',
        bottom: 0,
        top: '10%',
        zIndex: 10000,
      }}
      variant="filled"
      severity={
        homeModelPlacementError === HomePlacementErrors.FLOOD_ZONE_WARNING
          ? 'warning'
          : 'error'
      }
    >
      {message}
    </Alert>
  );
};
